import { DealDocument, DealDocumentType } from "../../../api/generated-api";
import React, { MutableRefObject, useEffect, useRef } from "react";

type HiddenInputFileProps = {
  dataTestId: string;
  documentFileRef: MutableRefObject<HTMLInputElement>;
  onChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const HiddenInputFile = ({
  dataTestId,
  documentFileRef,
  onChangeHandler,
}: HiddenInputFileProps) => {
  return (
    <input
      type="file"
      data-testid={dataTestId}
      accept={".docx,.pdf"} //make sure this matches what the server allows
      ref={documentFileRef}
      onChange={onChangeHandler}
      style={{ display: "none" }}
    />
  );
};

type Props = {
  visible: boolean;
  dataTestId: string;
  documentType: DealDocumentType;
  onDocumentSelect: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => Promise<DealDocument>;
  onCancel: () => void;
  onDocumentSelected: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onDocumentFinishedUploading?: () => void;
};

export const UploadDealDocumentFilePicker = ({
  visible,
  dataTestId,
  onDocumentSelect,
  onCancel,
  onDocumentSelected,
  onDocumentFinishedUploading,
}: Props) => {
  const documentFileRef = useRef<HTMLInputElement>(null);

  //This detects the cancel button clicked with no file on the file upload dialog
  window.onfocus = () => {
    setTimeout(() => {
      if (documentFileRef?.current?.files?.length === 0) {
        onCancel();
      }
    }, 300);
  };

  useEffect(() => {
    if (visible) {
      documentFileRef.current.click();
    }
  }, [visible]);

  return (
    <HiddenInputFile
      dataTestId={dataTestId}
      documentFileRef={documentFileRef}
      onChangeHandler={async (event) => {
        onDocumentSelected(event);
        await onDocumentSelect(event);
        if (onDocumentFinishedUploading) {
          onDocumentFinishedUploading();
        }
      }}
    />
  );
};
